import React from 'react';

import { ThemeProvider, createTheme } from '@mui/material/styles';

import RouteIndex from './routers/routes/index';

const theme = createTheme({
  typography: {
    fontFamily: 'Noto Sans JP, sans-serif'
  }
});

const App: React.FC = () => (
  <>
    <ThemeProvider theme={theme}>
      <RouteIndex />
    </ThemeProvider>
  </>
);

export default App;
